/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  siteList: [],
  modelEquipmentList: [],
  equipmentData: null,
  isEquipmentEdit: false,
  isEquipmentVisible: false,
  ownerlist: '',
  newOwner: null,
  addSite: null,
  getSiteData: null,
  upDateSite: null,
  deletedSiteStatus: null,
  reportsForSite: null,
};

const sitandequReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'SITE_LIST':
      return {
        ...state,
        siteList: action.value,
        isEquipmentEdit: false,
      };
    case 'MODELEQUIPMENT_LIST':
      return {
        ...state,
        modelEquipmentList: action.value,
      };
    case 'EQUIPMENT_DATA':
      return {
        ...state,
        equipmentData: action.value,
        isEquipmentEdit: true,
        isEquipmentVisible: true,
      };
    case 'ISEQUIPMENT_VISIBLE':
      return {
        ...state,
        isEquipmentEdit: action.payload.edit,
        isEquipmentVisible: action.payload.visible,
      };
    case 'DRAGANDDROP':
      return {
        ...state,
        siteList: action.value,
      };
    case 'ownerList':
      return {
        ...state,
        ownerlist: action.value,
      };
    case 'ADD_OWNER_SUCCESS':
      return {
        ...state,
        newOwner: action.value,
      };
    case 'GET_SITE_SUCCESS':
      return {
        ...state,
        getSiteData: action.value,
      };
    case 'GET_EQUIPMENT_SUCCESS':
      return {
        ...state,
        getEqipmentData: action.value,
      };
    case 'ADD_SITE_SUCCESS':
      return {
        ...state,
        addSite: action.value,
      };
    case 'CLEAR_OWNER_VALUE':
      return {
        ...state,
        newOwner: '',
      };
    case 'CLEAR_SITE_VALUE':
      return {
        ...state,
        addSite: '',
      };
    case 'UPDATE_OWNER_SUCCESS':
      return {
        ...state,
        upDateSite: action.value,
      };
    case 'CLEAR_UPDATE_SUCCESS':
      return {
        ...state,
        upDateSite: '',
      };
    case 'DELETE_SITE':
      return {
        ...state,
        deletedSiteStatus: action.value,
      };
    case 'CLEAR_DELETE_SITE_SUCCESS':
      return {
        ...state,
        deletedSiteStatus: '',
      };
    case 'REPORTS_FOR_SITE':
      return {
        ...state,
        reportsForSite: action.value,
      };
    default:
      return state;
  }
};

export default sitandequReducer;
